import { render, staticRenderFns } from "./DialogCom.vue?vue&type=template&id=4e39ff63&"
import script from "./DialogCom.vue?vue&type=script&lang=js&"
export * from "./DialogCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports